import React, { ReactNode } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles';

const Placeholder = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();
  const useStyles = makeStyles(() => ({
    root: {
      color: theme.palette.text.secondary,
      fontSize: 14,
      fontWeight: 400,
    },
  }));
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default Placeholder;
